module.exports = {
      id: "recharge--marker-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "images/sprites/poi.svg#recharge--marker-usage",
      toString: function () {
        return this.url;
      }
    }